'use strict';

var _require = require('./src/url'),
    URLWithLegacySupport = _require.URLWithLegacySupport,
    format = _require.format,
    URLSearchParams = _require.URLSearchParams,
    defaultBase = _require.defaultBase;

var relative = require('./src/relative');

module.exports = {
  URL: URLWithLegacySupport,
  URLSearchParams: URLSearchParams,
  format: format,
  relative: relative,
  defaultBase: defaultBase
};